import { render, staticRenderFns } from "./LoadingContainer.vue?vue&type=template&id=386ae240&scoped=true&"
import script from "./LoadingContainer.vue?vue&type=script&lang=js&"
export * from "./LoadingContainer.vue?vue&type=script&lang=js&"
import style0 from "./LoadingContainer.vue?vue&type=style&index=0&id=386ae240&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386ae240",
  null
  
)

export default component.exports